export default function createCounter(max) {
    let curr = 0;
    const step = 1;
    return {
        next() {
            curr += step;
            if (curr > max) {
                curr = 0;
            }
            return curr;
        },
        prev() {
            curr -= step;
            if (curr < 0) {
                curr = max;
            }
            return curr;
        },
        reset() {
            curr = 0;
            return curr;
        },
        current() {
            return curr % max;
        },
    };
}
